module.exports = __webpack_public_path__ + "static/media/4.b15f0a0e.jpg";